import { UI_CONSTANTS } from '@edassist/shared';

export class FileService {
	static getFileExtension(fileName: string): string {
		return `.${UI_CONSTANTS.PATTERNS.FILE_EXTENSION.exec(fileName)[1]}`;
	}

	static getMimeType(mimeType: string): string {
		let extension: string;
		switch (mimeType) {
			case 'application/msword':
			case 'application/x-tika-msoffice':
				extension = 'application/msword';
				break;
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			case 'application/x-tika-ooxml':
				extension = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				break;
			default:
				extension = mimeType;
		}

		return extension;
	}

	static getContentType(fileExtension: string): string {
		let type: string;
		switch (fileExtension) {
			case '.pdf':
				type = 'application/pdf';
				break;
			case '.docx':
				type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				break;
			case '.doc':
				type = 'application/msword';
				break;
			case '.xls':
			case '.xlt':
			case '.xla':
				type = 'application/vnd.ms-excel';
				break;
			case '.xlsx':
				type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				break;
			case '.jpg':
			case '.jpeg':
			case '.jpe':
			case '.jif':
			case '.jfif':
				type = 'image/jpeg';
				break;
			case '.gif':
				type = 'image/gif';
				break;
			case '.tif':
			case '.tiff':
				type = 'image/tiff';
				break;
			case '.bmp':
				type = 'image/bmp';
				break;
			case '.svg':
				type = 'image/svg+xml';
				break;
			default:
				type = 'image/png';
		}

		return type;
	}
}
